import { render, staticRenderFns } from "./classical-exam-adjustment-form.vue?vue&type=template&id=c6096d14"
import script from "./classical-exam-adjustment-form.vue?vue&type=script&lang=js"
export * from "./classical-exam-adjustment-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports